import { Link } from "react-router-dom";
import { RLCard } from "../../../../../../components";
import shortNumberFormat from "../../../../../../tcbase/utils/short_number_format";
import {
  useGetReportSummary,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { pathToSS } from "../../../../util";
import StaticAnalysisInsightsGrid from "./StaticAnalysisInsightsGrid";

import { COMPONENT_IDS } from "../../../../consts";
import commonStyles from "../../../../containers/report_summary/report-summary.module.scss";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { Tooltip } from "../common";

const StaticAnalysisInsightsCard = () => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();

  const { data: reportSummaryData, isLoading } = useGetReportSummary(
    hash,
    sourceId,
    relationshipId
  );

  const indicatorsCount = reportSummaryData?.indicators.count ?? 0;

  return (
    <RLCard
      header={
        <RLCard.LinkHeader
          title={
            <Tooltip
              placement="top"
              message={
                <div>
                  <span>
                    {DESCRIPTIONS[COMPONENT_IDS.STATIC_ANALYSIS_INSIGHTS]}
                  </span>
                  <br />
                  <span>
                    Total number of static analysis indicators:{" "}
                    {shortNumberFormat(indicatorsCount)}.
                  </span>
                </div>
              }
            >
              <span data-testid="report_summary_static_analysis_insights_title">
                {`Static Analysis Insights (${shortNumberFormat(
                  indicatorsCount
                )})`}
              </span>
            </Tooltip>
          }
          LinkComponent={
            <Link
              to={pathToSS(
                hash,
                sourceId,
                "ticore/indicators/",
                relationshipId
              )}
              className={commonStyles.link}
              data-testid="report_summary_static_analysis_insights_see_all_link"
            >
              See All Indicators
            </Link>
          }
        />
      }
      content={
        <RLCard.Content data-testid="report_summary_static_analysis_insights_grid">
          <StaticAnalysisInsightsGrid
            indicators={reportSummaryData?.indicators}
            isLoading={isLoading}
          />
        </RLCard.Content>
      }
      data-testid="report_summary_static_analysis_insights_card"
    />
  );
};

export default StaticAnalysisInsightsCard;
